var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-table',{ref:"table",staticStyle:{"margin-top":"8px"},attrs:{"scroll":{
      x: ((_vm.columns.length) + "0%"),
      y:270
    },"size":"middle","rowKey":"id","columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":false,"rowSelection":null,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }